export const START_CALL_MODAL = 'START_CALL_MODAL';
export const START_CALL_SELECT = 'START_CALL_SELECT';
export const START_CALL_SELECT_CUSTOM = 'START_CALL_SELECT_CUSTOM';
export const START_CALL_FORM = 'startCallSearch';
export const START_CALL_FORM_FOCUSED = 'START_CALL_FORM_FOCUSED';
export const CALL_ONE_TIME = 'CALL_ONE_TIME';
export const START_ROUTE = '/start';
